import PillarPageLayout from "@/components/PillarPageLayout";
export default function CartographieViticolePage() { return <PillarPageLayout slug="cartographie-viticole" />; }
